import { Bar, mixins } from 'vue-chartjs'

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
            this.chartOptions = {
                    responsive: true,
                    cutoutPercentage: 92,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    scales: {
                        xAxes: [{
                            barPercentage : 1.5
                        }]
                    }
            };
            this.renderChart(this.chartData, this.chartOptions)
    }
});



// WEBPACK FOOTER //
// ./src/tools/charts/reports/newReport.js